import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {} from '../Dashboard/UserActions';
import {SearchWorkItemRecords, ScoreCalculation} from '../WorkListing/WorklistingAction';
import SearchFile from './SearchFile';

class SearchWorkItemindex extends Component {
  componentDidMount(){    
    this.props.actioninventoryUserMapped()    
  }
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}  
    return(  
      <div  className={(style) ? 'user' : "userSmall"}>
        <SearchFile inventory={this.props.inventoryMapped} action={this.props} searchRecord={this.props.searchRecord}
        ScoreCalculation={this.props.ScoreCalculation}/>    
      </div>
    )   
  }
}
function mapStateToProps(state){
  return{    
    size: state.UserReducer.large,    
    inventoryMapped: state.UserReducer.inventoryMapped,  
    searchRecord: state.WorklistingReducer.searchRecord,
    ScoreCalculation:  state.WorklistingReducer.ScoreCalculation, 
  } 
}

const mapDispatchToProps = (dispatch) => ({  
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  SearchWorkItemRecords:  (a) =>dispatch(SearchWorkItemRecords(a)),   
  auditorScoreCalculation: (a) =>dispatch(ScoreCalculation(a)), 
  TokenValidation : (a) => dispatch(TokenValidation(a))
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchWorkItemindex);
